import type { ICianMFUIElement } from '@cian/mf-registry/browser';

import { useEffect, useRef, useState } from 'react';

interface IUseAdBannerMicrofrontend {
  microfrontendRef: React.RefObject<ICianMFUIElement | null>;
  isReady: boolean;
}

/**
 * Откладывает монтирование микрофронтенда до клиента: реклама не должна рендериться на SSR,
 * иначе разметка сервера и браузера разойдутся.
 */
export function useAdBannerMicrofrontend(): IUseAdBannerMicrofrontend {
  const microfrontendRef = useRef<ICianMFUIElement | null>(null);
  const [isReady, setReady] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setReady(true), 0);

    return () => clearTimeout(timeoutId);
  }, []);

  return { isReady, microfrontendRef };
}
